import React from 'react'
import Yup from '../../../../helpers/custom-yup'
import Title from '../../../../components/typography/title.component'
import Modal from '../../../../components/modal/modal.component'
import banner from '../../../../../assets/images/banners-club/desktop.png'
import moment from 'moment'
import Button from '../../../../components/buttons/buttons.component'
import AntiFraud from '../../../../components/form-components/anti-fraud.component'
import bannerMobile from '../../../../../assets/images/banners-club/mobile.png'
import CreditCardList from '../../../../components/credit-cards/credit-cards-list.component'
import InnerPageContainer from '../../../../components/layout/private/inner-page-container.component'
import { Link } from 'react-router-dom'
import { Formik } from 'formik'
import { routes } from '../../../../constants/routes.constants'
import { connect } from 'react-redux'
import { CardInfo } from '../../../../components/credit-cards/card-info.component'
import { PlansTable } from '../../../../components/layout/plans-table/plans-table.component'
import { ClubService } from '../../../../services'
import { StyledMyPlan } from './styles/my-plan.style'
import { PlansLogoRouter } from '../../../../components/plans-logos'
import { bindActionCreators } from 'redux'
import { Creators as SiteCreators } from '../../../../ducks/site/site'
import { userActions, toastActions } from '../../../../actions'
import {
	isMobile,
	mapRecurrenceTypeFromEnglishToPortuguese
} from '../../../../helpers'

class MyPlanPage extends React.Component {
	state = {
		modalIsOpen: false,
		planId: null,
		recurrenceType: null,
		newPlan: null,
		planExpirationDate: moment()
			.add(1, 'year')
			.format('DD/MM/YYYY')
	}

	componentWillMount() {
		this.props.updatePlan()
	}

	onChangePlan = (id, recurrenceType) => () => {
		this.setState({ planId: id, recurrenceType }, () => {
			ClubService.getPlans()
				.then(plans =>
					this.setState(
						{ newPlan: plans.filter(plan => plan.id === id)[0] },
						() => this.setState({ modalIsOpen: true })
					)
				)
				.catch(console.log)
		})
	}

	onSubmit = ({ securityCode }) => {
		const { planId, recurrenceType } = this.state

		const {
			creditCards,
			deviceId,
			hideLoading,
			showLoading,
			danger,
			success,
			updatePlan
		} = this.props

		showLoading()

		const data = {
			securityCode,
			planId,
			cardId: creditCards.filter(card => card.main)[0].id,
			recurrenceType: mapRecurrenceTypeFromEnglishToPortuguese(
				recurrenceType
			),
			deviceId
		}

		ClubService.changePlan(data)
			.then(data => {
				if (data.success) {
					this.setState({ modalIsOpen: false })
					success({
						message: 'Parabéns! Seu plano foi alterado com sucesso'
					})
					updatePlan()
				} else {
					danger({ message: data.errors })
				}

				hideLoading()
			})
			.catch(error => {
				hideLoading()
				danger({ message: error })
			})
	}

	render() {
		const {
			modalIsOpen,
			newPlan,
			recurrenceType,
			planExpirationDate
		} = this.state

		const { plan } = this.props

		return (
			<InnerPageContainer>
				<AntiFraud />

				<Title>Clube Muviflex</Title>

				{isMobile() ? (
					<img
						src={bannerMobile}
						alt="Banner meus planos do clube muviflex"
						style={{ width: '100%' }}
					/>
				) : (
					<img
						src={banner}
						alt="Banner meus planos do clube muviflex"
						style={{ width: '100%' }}
					/>
				)}

				{plan && (
					<React.Fragment>
						<h3 className="orange semi-bold">Sua assinatura</h3>
						<StyledMyPlan>
							<div className="plan">
								<PlansLogoRouter id={plan.planId} fontSize="36" />
								<div className="plan-info">
									Data da adesão: {plan.accessionDate.split(' ')[0]}{' '}
									<br />
								Situação:{' '}
									{plan.status == 'Active' ? 'Ativo' : 'Inativo'} <br />
								Tipo de plano:{' '}
									{plan.recurrenceType == 'Yearly'
										? 'Anual'
										: 'Mensal'}{' '}
									<br />
									{plan.recurrenceType === 'Monthly' &&
										`Recorrência cobrança: Todo dia ${plan.billingDay}`}
									{plan.pending && (
										<Link
											to={`${routes.CLIENTE}/regularizar-assinatura`}>
											<Button primary small>
												Regularizar assinatura
										</Button>
										</Link>
									)}
								</div>
							</div>
							<div className="cards">
								<CreditCardList />
							</div>
						</StyledMyPlan>
					</React.Fragment>
				)}

				<h3 className="orange semi-bold">
					Confira as opções de planos disponíveis
				</h3>

				<PlansTable logged onButtonClick={this.onChangePlan} />

				<Modal
					ref="modal"
					isOpen={modalIsOpen}
					title="Alteração de plano"
					onClose={() => this.setState({ modalIsOpen: false })}>
					<p>
						Aviso! Nas trocas de plano para um Tipo de plano com pagamento
						anual, uma nova cobrança será feita no momento da confirmação
						da mudança, assim como um novo crédito de pontos será
						efetuado.
					</p>
					{newPlan && (
						<p>
							Plano {newPlan.name} <br />
							Valor do pagamento:{' '}
							{recurrenceType == 'monthly'
								? Number(newPlan.amount).$toReais()
								: Number(newPlan.annualAmmount).$toReais()}{' '}
							<br />
							{!!plan && recurrenceType == 'monthly' &&
								`Data da cobrança: Todo dia ${plan.billingDay}`}
							<br />
							{recurrenceType == 'yearly' &&
								`Data de término do plano: ${planExpirationDate}`}
							Renovação: Automática
						</p>
					)}
					<Formik
						initialValues={{ securityCode: '' }}
						validationSchema={Yup.object().shape({
							securityCode: Yup.string().required(
								'Informe o código de segurança'
							)
						})}
						onSubmit={this.onSubmit}
						render={props => (
							<form noValidate onSubmit={props.handleSubmit}>
								<CardInfo {...props} />
								<p>Você confirma a alteração de plano?</p>
								<div
									style={{
										display: 'flex',
										justifyContent: 'flex-end'
									}}>
									<Button
										secondary
										style={{ marginRight: '15px' }}
										onClick={this.refs.modal.close}
										type="button">
										Não
									</Button>
									<Button primary type="submit">
										Sim
									</Button>
								</div>
							</form>
						)}
					/>
				</Modal>
			</InnerPageContainer>
		)
	}
}

const mapStateToProps = ({ creditCards, user, antiFraud }) => ({
	...creditCards,
	plan: user.plan,
	deviceId: antiFraud.sessionID
})

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			danger: toastActions.danger,
			success: toastActions.success,
			updatePlan: userActions.updatePlan,
			hideLoading: SiteCreators.hideLoading,
			showLoading: SiteCreators.showLoading
		},
		dispatch
	)

const connectedMyPlanPage = connect(
	mapStateToProps,
	mapDispatchToProps
)(MyPlanPage)

export { connectedMyPlanPage as ModuleRootComponent }
